import { useState } from 'react';
import { Group, InputControl, InputRoot } from '@optiaxiom/react';
import { Pill } from '@optiaxiom/react/unstable';

type TagInputProps = {
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  disabled?: boolean;
  /** Blocks adding past this count while always leaving removal available,
   * so a caller enforcing a schema max doesn't lock the user out of fixing it. */
  maxItems?: number;
};

export function TagInput({
  value,
  onChange,
  placeholder = 'Add tag...',
  disabled,
  maxItems,
}: TagInputProps) {
  const [inputValue, setInputValue] = useState('');
  const atMax = maxItems !== undefined && value.length >= maxItems;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const trimmed = inputValue.trim();
      if (trimmed && !atMax && !value.includes(trimmed)) {
        onChange([...value, trimmed]);
        setInputValue('');
      }
    } else if (e.key === 'Backspace' && inputValue === '' && value.length > 0) {
      onChange(value.slice(0, -1));
    }
  };

  const handleRemoveTag = (index: number) => {
    onChange(value.filter((_, i) => i !== index));
  };

  return (
    <InputRoot addonPointerEvents="none" h="auto" p="6">
      <Group gap="4" flexWrap="wrap" alignItems="center">
        {value.map((tag, index) => (
          <Pill key={tag} onDismiss={disabled ? undefined : () => handleRemoveTag(index)}>
            {tag}
          </Pill>
        ))}
        <InputControl
          value={inputValue}
          onValueChange={setInputValue}
          onKeyDown={handleKeyDown}
          placeholder={value.length === 0 ? placeholder : ''}
          disabled={disabled || atMax}
          flex="1"
        />
      </Group>
    </InputRoot>
  );
}
